import React from 'react'
import "./modal-body.css";


export default function ModalBody() {
  return (
    <div>
      <div className="accordion" id="accordionExample">
        <div className="card">
          <div className="card-header" id="headingOne">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              (Shear Stability) پايداری برشی  
              </button>
            </h2>
          </div>

          <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"> </span>پایداری برشی، معیار مقاومت سیال انتقال اتوماتیک در برابر تغییرات ویسکوزیته در مواجهه با تنش های برشی به وجود آمده در بین دو دیسک گردنده با فاصله کم  و یا نیروهای مکانیکی وارده بر آن می باشد. هرچه پایداری برشی بیشتر باشد، بیانگر آن است که شکست زنجیره های مولکولی در تنش های وارده کمتر اتفاق افتاده و سیال، گرانروی و خاصیت اولیه خود را بیشتر حفظ می کند. استفاده از پلیمرهای بهینه شده در سیال های انتقال اتوماتیک، که پایداری بیشتری در برابر تنش های برشی وارده دارند، باعث ثبات گرانروی و در نتیجه افزایش راندمان سیال خواهد شد. 


              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingTwo">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              (Oxidation Stability) پایداری در برابر اکسیداسیون  
              </button>
            </h2>
          </div>
          <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span>  سیال های انتقال اتوماتیک به مرور زمان به دلیل افزایش گرما در حین کار در گیربکس های اتوماتیک اکسیده می شوند و این امر سبب کاهش طول عمر این سیال می شود، زیرا فرایند اکسیداسیون باعث تشکیل اسید شده که به عنوان یک ماده خورنده عمل می کند و از طرفی منجر به تشکیل لجن می گردد که همگن بودن و یکنواختی این سیال را از بین برده و  باعث افت عملکرد آن می شود. با پیشرفت تکنولوژی از روغن های پایه سینتتیک و افزودنی های آنتی اکسیدان در سیال های انتقال اتوماتیک استفاده می شود که اکسیداسیون را کاهش داده و باعث افزایش طول عمر سیال و کاهش هزینه ها می شود. 

              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingThree">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              (Friction Durability) ماندگاری در برابر اصطکاک  
              </button>
            </h2>
          </div>
          <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span>سیال انتقال اتوماتیک علاوه بر انتقال قدرت، وظیفه روانکاری در قطعاتی مانند محورها، چرخ دنده ها و یاتاقانها را بر عهده دارد. تشکیل لجن، ایجاد کف و وجود ذرات معلق (به دلیل سایش قطعاتی) ، باعث افت روانکاری در سیال های انتقال اتوماتیک می شوند. این عوامل سبب کاهش طول عمر قطعات و سیال شده می شود. استفاده از افزودنی های خاص کاهش دهنده سایش و اصطکاک در ای سیال ها، باعث می شود که روانکاری سطوح در حال تماس با یکدیگر به خوبی صورت پذیرفته و علاوه بر تسریع و نرمی انتقال نیرو در هنگام تعویض دنده ها، سایش، سر و صدا و گرمای تولید شده را کاهش می دهند. 
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingFour">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              (Anti-Shudder Durability) مقاومت در برابر لرزش  
              </button>
            </h2>
          </div>
          <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span> با افزایش نیروی گشتاور در اتومبیل های جدید، شاهد بروز پدیده لرزش در گیربکس های انتقال اتوماتیک هستیم که این امر باعث ایجاد تکان های شدید و ایجاد سرو صدا و کاهش نیروی حرکتی می شود. با پیشرفت تکنولوژی در سالهای اخیر، از  افزودنی هایی در سیالات انتقال اتوماتیک استفاده می شود که دارای مشخصه ضد لرزش بهتری هستند.
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header" id="headingFive">
            <h2 className="mb-0">
              <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
              (Brookfield) (ویسکوزیته در دمای سرد) بروکفیلد  
              </button>
            </h2>
          </div>
          <div id="collapseFive" className="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
            <div className="card-body">
              <div className="glossary-right">
                <span className="glossary-keyword"></span>  تست بروکفیلد با اندازه گیری ویسکوزیته در دماهای بسیار پایین این امکان را فراهم می سازد تا اطمینان حاصل کنیم سیال در هنگام روشن کردن خودرو در هوای سرد، میتواند به مانند شرایط عادی در گیربکس جریان داشته باشد. اگر بروکفیلد سیال انتقال اتوماتیک، خیلی بالا باشد، سیالیت و گردش آن با مشکل مواجه می شود که خرابی و سایش قطعات را به دنبال خواهد داشت. در نتیجه هرچه بروکفیلد برای یک سیال انتقال اتوماتیک به ویسکوزیته در دمای کارکرد گیربکس اتوماتیک نزدیک تر باشد، راندمان سیال بیشتر خواهد بود. امروزه در سیالات انتقال اتوماتیک از روغن های پایه سینتتیک که در برابر تغییرات دما (به خصوص دماهای پایین)، ثبات گرانروی بیشتری دارند استفاده می شود. 
              </div>
            </div>
          </div>
        </div>
      
  
      </div>
    </div>
  )
}
